import { Skeleton } from "@omnabase/ui";

/** The dashboard while its numbers load (polish round two): the greeting, the "Needs you" rows and the Activity card (the home-and-customers round) in grey, still blocks
 *  where they will stand, in the dashboard's own two columns. */
export function HomeSkeleton() {
  return (
    <main className="ob-page ob-home ob-home--split" aria-label="Dashboard" aria-busy="true">
      <div className="ob-home__cols">
        <section className="ob-home__col ob-home__col--primary">
          <div className="ob-home__greeting"><Skeleton shape="line" width="45%" height="1.75em" /></div>
          <header className="ob-home__colhead"><Skeleton shape="line" width="25%" /></header>
          <div className="ob-needs">{[0, 1, 2].map((i) => <Skeleton key={i} shape="row" />)}</div>
        </section>
        <section className="ob-home__col ob-home__col--secondary">
          <Skeleton shape="line" width="35%" />
          <header className="ob-home__colhead"><Skeleton shape="line" width="25%" /></header>
          <div className="ob-activity"><Skeleton shape="line" width="30%" height="2em" /><Skeleton shape="line" width="55%" /><Skeleton shape="block" height={96} /><Skeleton shape="line" width="80%" /></div>
        </section>
      </div>
    </main>
  );
}
